// extracted by mini-css-extract-plugin
export default {"container":"App_container__0nfJb","list":"App_list__WnXtq","wrapper":"App_wrapper__lox9h","addButton":"App_addButton__1uvkw"};